import { theme } from '@branchjs/neo-components';
import { css, cx } from '@emotion/css';
import React from 'react';
import type { IndicatorProps, ValueContainerProps } from 'react-select';
import { components } from 'react-select';
import Icons from '../../../../../styles/Icons';

const DropdownIndicator = (props: IndicatorProps) => {
  const DROPDOWN_INDICATOR_STYLE_KEY = 'dropdownIndicator';
  const {
    getStyles,
    innerProps,
    isDisabled,
    selectProps: { menuIsOpen },
  } = props;
  const providedStyling = css(getStyles(DROPDOWN_INDICATOR_STYLE_KEY, props));
  const customStyles = {
    indicatorContainer: css({
      cursor: 'pointer',
      padding: '0px',
    }),
    indicator: css({
      fontFamily: 'Material Icons',
      fontSize: theme.typography.h3.fontSize,
      color: isDisabled ? theme.colors.gray[400] : theme.colors.gray[800],
      paddingRight: '5px',
    }),
  };
  const { indicatorContainer, indicator } = customStyles;
  const indicatorIcon = menuIsOpen ? Icons.KEYBOARD_ARROW_UP : Icons.KEYBOARD_ARROW_DOWN;
  return (
    <span className={cx('Select-arrow-zone', 'Select-arrow', providedStyling, indicatorContainer)} {...innerProps}>
      <span className={indicator}>{indicatorIcon}</span>
    </span>
  );
};

const ValueContainer = (props: ValueContainerProps) => {
  const styles = {
    wrapper: css({
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
    }),
    androidIcon: css({
      fontFamily: 'Material Icons',
      fontSize: 18,
      fontStyle: 'normal',
      color: props.isDisabled ? theme.colors.gray[400] : theme.colors.gray[800],
      marginLeft: '15px',
    }),
  };
  const { wrapper, androidIcon } = styles;
  return (
    <div className={wrapper}>
      <i className={androidIcon}>{Icons.SMARTPHONE}</i>
      <components.ValueContainer {...props} />
    </div>
  );
};

export default {
  DropdownIndicator,
  ValueContainer,
  Input: () => null,
};
